import {Component, OnInit} from '@angular/core';
import {BmCustomerBillingTransactionTypeBaseComponent} from '../bm-customer-billing-transaction-type-base.component';


@Component({
    selector: 'bm-customer-billing-transaction-type-full',
    templateUrl: 'bm-customer-billing-transaction-type-full.component.html',
    standalone: false
})
export class BmCustomerBillingTransactionTypeFullComponent extends BmCustomerBillingTransactionTypeBaseComponent implements OnInit {

    ngOnInit() {
        super.ngOnInit();
    }

}
